import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const FontSizeIcon = (props?: SvgProps) => (
  <svg
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M8.2373 5.46117C8.54166 5.3528 8.87435 5.35278 9.17871 5.46117L9.32812 5.52464L9.44531 5.59105C9.70394 5.75851 9.85503 6 9.94336 6.1555C10.054 6.35038 10.1691 6.60673 10.292 6.87718L15.0889 17.4289L15.1201 17.51C15.2563 17.9142 15.0675 18.3637 14.6709 18.5442C14.274 18.7246 13.8098 18.572 13.5947 18.2034L13.5557 18.1262L11.7383 14.1282H5.67773L3.86035 18.1262C3.66789 18.5496 3.16852 18.7366 2.74512 18.5442C2.32188 18.3516 2.13473 17.8523 2.32715 17.4289L7.12402 6.87718C7.24695 6.60675 7.36198 6.35037 7.47265 6.1555C7.57357 5.97784 7.75627 5.68801 8.08789 5.52464L8.2373 5.46117ZM8.65722 7.57445L6.44336 12.4446H10.9727L8.75879 7.57445C8.74097 7.53525 8.72397 7.49811 8.70801 7.46312C8.69204 7.49813 8.67505 7.53523 8.65722 7.57445Z"
      fill="#B0B2B6"
    />
    <path
      d="M18.661 4.98242C18.8887 4.98253 19.107 5.07481 19.2655 5.23828L21.5106 7.55371C21.8344 7.8876 21.826 8.42134 21.4921 8.74512C21.1582 9.0684 20.6253 9.06021 20.3017 8.72656L19.5028 7.90234V16.0967L20.3017 15.2734L20.3651 15.2148C20.6916 14.9402 21.1791 14.9517 21.4921 15.2549C21.826 15.5787 21.8344 16.1124 21.5106 16.4463L19.2655 18.7617C19.107 18.9252 18.8887 19.0175 18.661 19.0176C18.4333 19.0176 18.2151 18.9251 18.0565 18.7617L15.8104 16.4463L15.7538 16.3809C15.4891 16.046 15.516 15.5584 15.829 15.2549C16.142 14.9516 16.6295 14.9402 16.956 15.2148L17.0194 15.2734L17.8183 16.0967V7.90234L17.0194 8.72656L15.8104 7.55371L18.0565 5.23828L18.1181 5.17969C18.2692 5.05248 18.4617 4.98242 18.661 4.98242ZM17.0194 8.72656C16.6958 9.06016 16.1629 9.06845 15.829 8.74512C15.4951 8.42134 15.4867 7.8876 15.8104 7.55371L17.0194 8.72656Z"
      fill="#B0B2B6"
    />
  </svg>
)
